module.exports = __webpack_public_path__ + "img/icon-upload.6633dc06.svg";